function getRandomColor(lastColor = null) {
  const colors = [
    '#D9BA58',
    '#ECB495',
    '#4B7AC2',
    '#7DC6E0',
    '#82ADAD'
  ];

  let randomIndex;
  let newColor;

  do {
    randomIndex = Math.floor(Math.random() * colors.length);
    newColor = colors[randomIndex];
  } while (newColor === lastColor);

  return newColor;
}

function generateRandomBlobPath(width, height) {
  const numPoints = 8 + Math.floor(Math.random() * 4); // Random number of points between 6 and 9
  const points = [];
  const controlPoints = [];
  for (let i = 0; i < numPoints; i++) {
    const angle = (i / numPoints) * (2 * Math.PI);
    const radius = Math.random() * 0.3 + 0.8; // Random radius variation
    const x = (0.5 + 0.5 * radius * Math.cos(angle)) * width;
    const y = (0.5 + 0.5 * radius * Math.sin(angle)) * height;
    points.push({ x, y });
  }

  for (let i = 0; i < numPoints; i++) {
    const current = points[i];
    const next = points[(i + 1) % numPoints];
    const controlX = (current.x + next.x) / 2;
    const controlY = (current.y + next.y) / 2;
    controlPoints.push({ x: controlX, y: controlY });
  }

  let path = `M${controlPoints[0].x},${controlPoints[0].y}`;
  for (let i = 1; i < numPoints; i++) {
    const cp = controlPoints[i];
    const p = points[i];
    path += ` Q${p.x},${p.y} ${cp.x},${cp.y}`;
  }
  path += ` Q${points[0].x},${points[0].y} ${controlPoints[0].x},${controlPoints[0].y}Z`;

  return path;
}

function createBlob(width, height, color = null) {
  const blob = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  blob.setAttribute('d', generateRandomBlobPath(width, height));
  if (color) {
    blob.setAttribute('fill', color);
  } else {
    blob.setAttribute('fill', getRandomColor());
  }
  return blob;
}

function svgToDataURL(svgElement) {
  const svgString = new XMLSerializer().serializeToString(svgElement);
  const svgBlob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
  return URL.createObjectURL(svgBlob);
}

function createBlobElement(width, height, color = null) {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('width', width);
  svg.setAttribute('height', height);
  svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
  svg.setAttribute('preserveAspectRatio', 'none'); // Add this line
  svg.appendChild(createBlob(width, height, color));
  svg.classList.add('blob');

  return svgToDataURL(svg);
}

function createBlobHtmlElement(width, height) {
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("width", width);
  svg.setAttribute("height", height);
  svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
  svg.appendChild(createBlob(width, height));
  svg.classList.add('blob');
  return svg;
}
